import React, { useEffect, useState }   from "react";
import {Link}                           from "react-router-dom";

import "./navigation.scss";

export const Navigation = ({combinedItems}) => {
    return (
        <div className="navigation-nvg77">
            <div className="navigation-section">
                <div className="nav-grid">
                    {combinedItems?.map((item) => (
                        item.url.startsWith("http") ? (
                            <a href={item.url} className="card" key={item.name}>
                                <img src={item.icon} alt={item.name} />
                                <div className="content">
                                    <div className="name">{item.name}</div>
                                    <div className="description">{item.description}</div>
                                </div>
                            </a>
                        ) : (
                            <Link to={item.url} className="card" key={item.name}>
                                <img src={item.icon} alt={item.name} />
                                <div className="content">
                                    <div className="name">{item.name}</div>
                                    <div className="description">{item.description}</div>
                                </div>
                            </Link>
                        )
                    ))}
                </div>
            </div>
        </div>
    )
}
